module.exports = __webpack_public_path__ + "static/media/icono_panificacion.89e08bb9.png";